import React, { useEffect } from 'react';
import { useWebsiteConfig } from '../hooks/useWebsiteConfig';

const DynamicFavicon: React.FC = () => {
  const { config, loading, getImageUrl } = useWebsiteConfig();
  const favicon = config?.favicon;

  useEffect(() => {
    if (config && !loading && favicon) {
      const faviconUrl = getImageUrl(favicon);

      const updateFavicon = () => {
        try {
          const timestamp = Date.now();
          const newHref = `${faviconUrl}${faviconUrl.includes('?') ? '&' : '?'}v=${timestamp}`;

          let link = document.querySelector('link[rel="icon"]') as HTMLLinkElement;

          if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
          }

          const ext = faviconUrl.split('.').pop()?.toLowerCase().split('?')[0];
          let type = 'image/x-icon';
          if (ext === 'png') type = 'image/png';
          if (ext === 'svg') type = 'image/svg+xml';
          if (ext === 'gif') type = 'image/gif';
          if (ext === 'jpg' || ext === 'jpeg') type = 'image/jpeg';

          link.type = type;
          link.href = newHref;

          const shortcuts = document.querySelectorAll(
            'link[rel="shortcut icon"], link[rel="apple-touch-icon"]'
          );
          shortcuts.forEach((el) => {
            (el as HTMLLinkElement).href = newHref;
          });
        } catch (e) {
          console.error('Failed to update favicon:', e);
        }
      };

      const t = setTimeout(updateFavicon, 100);
      return () => clearTimeout(t);
    }
  }, [favicon, config, loading, getImageUrl]);

  useEffect(() => {
    if (config && !loading && config.siteName) {
      document.title = `${config.siteName} Admin Panel`;
    }
  }, [config, loading]);

  return null;
};

export default DynamicFavicon;
